import { AppModal } from '@components/form/Modal';
import NotificationBlocked from '@/assets/static/images/notification-blocked.png';
import { RiEqualizer2Line } from 'react-icons/ri';
import { MicPermissionType } from '../app-banner/banner.types';
import { Trans, useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

const NotificationPermissionModal = ({ open, onClose }: MicPermissionType) => {
  const { t } = useTranslation();
  return (
    <AppModal open={open} onCancel={onClose} centered footer={null} className="w-fit!">
      <AppModal.Body className="flex justify-between items-center px-5 py-6">
        <div className="flex items-center flex-col sm:flex-row gap-4 sm:gap-8">
          <img src={NotificationBlocked} alt="" />
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-2.5">
              <div className="text-xl font-medium text-text-900">{capitalize(t('notification_blocked'))}</div>

              <div className="text-sm text-text-600 max-w-[393px]">
                {t('notification_is_turned_off_please_enable_browser_notifications_to_stay_updated')}
              </div>
            </div>

            <div className="flex flex-col gap-4 text-text-500">
              <Trans
                i18nKey="click_the_page_info_icon_in_your_browsers_address_bar_notifications"
                components={[
                  <div className="flex flex-col"></div>,
                  <div className="text-sm text-text-500 flex items-center flex-wrap"></div>,
                  <RiEqualizer2Line className="mx-1.5" size={24} />,
                  <div className="text-sm text-text-500 pl-3"></div>,
                  <div className="text-sm text-text-500"></div>,
                ]}
              />
            </div>
          </div>
        </div>
      </AppModal.Body>
    </AppModal>
  );
};

export default NotificationPermissionModal;
